<template>
  <nav class="navigation-bar">
    <transition mode="out-in">
    
      <ul class="left-sidebar" v-if="!isMenuOpened && headerIsReady">
        <li class="nav-element">
          <span class="nav-link" @click="toggleGallery">Галерея</span>
        </li>
        <li class="nav-element">
          <div @click="openVideoPopup" class="nav-link video" :class="{'transparent' : (slideNumber===1 || videoPopupOpened)}">Видео</div>
        </li>
        <li class="nav-element">
          <a href="/penthouse-selection" class="nav-link  bottom-border">Подобрать пентхаус</a>
        </li>
        <!-- <li class="nav-element" >
          <div class="burger" >
            <div class="burger-box" @click="isActive = !isActive" :class="{ 'active': isActive}">
              <div class="burger-line"></div>
            </div>
          </div>
        </li> -->
      </ul>
    </transition>
  </nav>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import Button from "./common/Button"
  export default {
    name: "Header",
    components: {
      Button
    },
    data() {
      return {
        isMenuOpened: false,
        search: window.location.search,
        isActive: false,
        headerIsReady: false
      };
    },
    mounted() {
      this.headerIsReady = true;
      let close = document.querySelector('.menu-modal__close')
      close.addEventListener('click', (evt) => {
        evt.stopPropagation();
        this.isMenuOpened = false;
      })

      let open = document.querySelector('.header__burger p')
      open.addEventListener('click', (evt) => {
        evt.stopPropagation();
        this.isMenuOpened = true;
      })
    },
    watch: {
      search(newValue, oldValue) {
        return
      },
      slideNumber() {
        return this.slideNumber;
      }
    },
    computed: {
      ...mapState(['showGallery','slideNumber', 'videoPopupOpened']),
      menuIsOpened() {
        if (this.search && this.search.includes('menu')) {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      ...mapMutations(['toggleGallery', 'openVideoPopup']),
    }
  }
</script>

<style lang="stylus" scoped>
  @import '../styles/tools'
  nav 
    @media (max-width 1000px)
      width-between-property 'max-width' 320 250 1000 650 true true
  ul
    padding 0
    margin 0
    box-sizing border-box
    padding-inline-start 0
    margin-block-start 0
    margin-block-end 0
  .navigation-bar
    display flex
    justify-content flex-start
    align-items center
    width 100%
    position fixed
    z-index 25
    box-sizing border-box
    background-color transparent
    padding 33px 0
    @media (max-width 1000px)
      position fixed
    @media (max-width 600px)
      padding-top 50px
    @media (min-width 600px) and (max-width 1000px)
      padding 50px 20px 0 110px
    @media (min-width: 1000px)
      justify-content flex-start
      padding-right 80px
      padding-left calc(10vw + 80px)
      width-between-property 'padding-right' 1000 15 1680 80 true true

  .left-sidebar, .right-sidebar
    display flex
    justify-content center
    align-items center
    padding-top 12px
    transition opacity .3s ease-in-out
    transition-delay .5s
    @media (min-width 1000px)
      width 47%
      justify-content flex-start
      margin 0

    &.v-enter
    &.v-leave-to
      opacity 0



  .nav-element
    list-style none
    margin 0 auto
    @media (max-width 1000px)
      margin-left 10px
      margin-right 10px
    @media (min-width 1000px)
      margin 0
      width-between-property 'margin-right' 1000 25 1680 50 true true
    &:last-child
      margin 0 auto
      @media (max-width 1000px)
        margin-left 10px
      @media (min-width 1000px)
        margin 0
        // margin-left 40px
        // width-between-property 'margin-left' 1000 10 1680 80 true true

  .nav-link
    display inline-flex
    text-transform uppercase
    font-family AsketBold
    font-weight bold
    width-between-property 'font-size' 320 8 768 10 true true
    transition transform .3s
    color $white
    cursor pointer
    text-decoration none

    @media (min-width 600px) and (max-width 1000px)
      font-size 14px
      width-between-property 'font-size' 600 10 768 14 true true
    @media (min-width 1000px)
      width-between-property 'font-size' 1000 12 1920 14 true true

  .burger
    font-family AsketBold
    font-weight bold
    font-size 14px
    transition transform .3s
    color $white
    cursor pointer
    text-decoration none
    transform translateY(30%)


  .burger-box
    position: relative
    display inline-flex
    width: 30px
    height: 24px
    cursor pointer
    &.active .burger-line
      transition-delay .12s
      transition-timing-function ease-in-out
      transform rotate(45deg)
    &.active .burger-line:after
      top 0
      transition top 75ms ease,opacity 75ms ease .12s
      opacity 0
    &.active .burger-line:before
      top 0
      transition bottom 75ms ease,transform 75ms ease-in-out .12s
      transform rotate(-90deg)


  .burger-line, .burger-line:after, .burger-line:before
    position: absolute
    width: 100%
    height 3px
    background-color $white
    border-radius 3px


  .burger-line
    transition-timing-function ease-in-out
    transition-duration 75ms
    top 20%


  .burger-line:after
    top 8px
    content " "
  .burger-line:before
    top -8px
    content " "

  .video
    position relative
    transition opacity .3s ease-in-out
    &.transparent
      opacity 0.3
      pointer-events none
    &:after
      content " "
      position absolute
      right -8px
      top 0px
      background url('../static/images/play.svg') no-repeat
      background-position  center
      background-size contain
      width 6px
      height 6px
      @media (min-width 600px) and (max-width 1000px)
        width-between-property 'width' 600 6 768 12 true true
        width-between-property 'height' 600 6 768 12 true true
        width-between-property 'right' 600 -8 768 -15 true true
      @media (min-width 1000px)
        width-between-property 'width' 1000 10 1920 12 true true
        width-between-property 'height' 1000 10 1920 12 true true
        width-between-property 'right' 1000 -9 1920 -14 true true
        width-between-property 'top' 1000 0 1920 -2 true true


  .bottom-border
    position: relative
    &:after
      position absolute
      bottom -2px
      left 0
      width 100%
      height: 2px
      content " "
      background-color $white

  .right-sidebar
    display none
    @media (min-width 1000px)
      display flex
      padding-right 20px      

  .bordered
    border-radius 32px
    border solid 1px $white
    padding 10px 15px 7px
  
  .video-unactive 
    cursor default
    opacity 0.3
    pointer-events none

</style>